import type { LoaderFunctionArgs } from 'react-router';
import { redirect, useLoaderData } from 'react-router';
import { GenericError } from '../../components/Error';
import { Unauthorized } from '../../components/Error/Unauthorized';
import { integrateWithPreservedAuthorization } from '../../features/integration/additional-sign-in';
import { IntegrationComplete } from '../../features/integration/components/IntegrationComplete';
import { IntegrationGuarantorEmailConflict } from '../../features/integration/components/IntegrationGuarantorEmailConflict';
import { hasAuthParams } from '../../utils/auth/hasAuthParams';
import { markReLoginRequired } from '../../utils/auth/reLoginRequired';

export async function integrationSignInCallbackLoader({ request }: LoaderFunctionArgs): Promise<{ status: number }> {
  const url = new URL(request.url);
  if (!hasAuthParams(url.search)) {
    // 認証クエリがない場合は home に戻す
    throw redirect('/home');
  }

  try {
    const result = await integrateWithPreservedAuthorization();
    if (result.status !== 205) {
      markReLoginRequired();
    }
    return result;
  } catch {
    markReLoginRequired();
    // 統合処理中のエラーは 401
    return { status: 401 };
  } finally {
    history.replaceState(null, '', location.pathname);
  }
}

export function IntegrationSignInCallbackPage() {
  const { status } = useLoaderData<typeof integrationSignInCallbackLoader>();
  switch (status) {
    case 205: {
      return <IntegrationComplete />;
    }
    case 400: // 同一アカウント同士の場合、画面としては同一
    case 401:
    case 403: {
      // 追加ログインが未認証の場合、画面としては同一
      return <Unauthorized />;
    }
    // 保護者メール衝突の場合のみ明示的にユーザに知らせる
    case 409: {
      return <IntegrationGuarantorEmailConflict />;
    }
    default: {
      return <GenericError />;
    }
  }
}
